<template>
  <div
    class="toolbar_undo toolbar-icon"
    :title="$t('title.undo')"
    :disabled="stateHistory.busy || !stateHistory.canUndo"
    @click="stateHistory.undo()"
  >
    <custom-icon :class-name="icons.Undo" />
  </div>
</template>
<script>
import { stateHistory } from "../../../store/state-history";
import { icons } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";

export default {
  components: { CustomIcon },
  data() {
    return {
      icons: icons,
    };
  },
  computed: {
    stateHistory() {
      return stateHistory;
    },
  },
  methods: {
    callFunc() {
      this.stateHistory.undo();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";
.toolbar_undo {
  padding: 0 0.3rem;
}
</style>
